import { isCreator, isOutCustomerService } from './utils/url';
import { getResourcesList } from '@/services';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface MENUS_CONFIG {
    id: string | number;
    name: string;
    link: string;
    activeLinks?: string[];
    icon?: string;
    iconUrl?: string;
    iconWidth?: number;
    iconHeight?: number;
    matchLink?: string;
    children?: MENUS_CONFIG[];
    unreadNumber?: number;
}

const customerServiceMenu: MENUS_CONFIG[] = [
    {
        id: 'order',
        name: '订单管理',
        link: '/main/v3/order',
        activeLinks: ['/refundDetails'],
        icon: 'icon_order',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'evaluation',
        name: '评价管理',
        link: '/evaluation',
        icon: 'icon_comment',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'message',
        name: '消息中心',
        link: '/messageCenter',
        icon: 'icon_message',
        activeLinks: ['/contract/cancel'],
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'platformRule',
        name: '平台规则',
        link: '/platformRule',
        icon: 'platform-rule',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
];

export const creatorMenus: MENUS_CONFIG[] = [
    {
        id: 'create',
        name: '内容管理',
        link: '/imageCreate',
        icon: 'edit-region',
        iconWidth: 19,
        iconHeight: 19,
        children: [
            {
                id: 'imageCreate',
                name: '图文创作',
                link: '/imageCreate',
                icon: 'daodianc-uploadpictures',
                iconWidth: 19,
                iconHeight: 19,
            },
            {
                id: 'videoCreate',
                name: '视频创作',
                link: '/videoCreate',
                icon: 'daodianb-uploadvideo',
                iconWidth: 19,
                iconHeight: 19,
            },
        ],
    },
];

const commonMenus: MENUS_CONFIG[] = [
    {
        id: 'manage',
        name: '服务管理',
        link: '/serviceList',
        activeLinks: ['/main/v3/add'],
        icon: 'icon_service_manager',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'order',
        name: '订单管理',
        link: '/main/v3/order',
        activeLinks: ['/refundDetails'],
        icon: 'icon_order',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'settlement',
        name: '财务结算',
        link: '/main/v3/settlement',
        icon: 'icon_settlement',
        iconWidth: 19,
        iconHeight: 19,
        children: [
            {
                id: 'settlement_service',
                name: '服务市场业务',
                link: '/main/v3/settlement',
            },
            {
                id: 'settlement_thirdpartnar',
                name: '代运营业务',
                link: '/settlementTP/balance',
                matchLink: '/settlementTP',
                activeLinks: ['/invoice'],
            },
        ],
    },
    {
        id: 'score',
        name: '得分状态',
        link: '/score',
        icon: 'icon_score_status',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'evaluation',
        name: '评价管理',
        link: '/evaluation',
        icon: 'icon_comment',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'staff',
        name: '员工管理',
        link: '/main/v3/staff',
        icon: 'icon_staff',
        activeLinks: ['/main/groupList', '/main/setMessage', '/main/addStaff'],
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'marketing',
        name: '营销中心',
        link: '/main/v3/marketing',
        icon: 'icon_marketting',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'message',
        name: '消息中心',
        link: '/messageCenter',
        icon: 'icon_message',
        activeLinks: ['/contract/cancel'],
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'freight',
        name: '物流管理',
        link: '/freight/list',
        icon: 'icon_freight_setting',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'live',
        name: '直播管理',
        link: '/live/list',
        icon: 'live_manage',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'client',
        name: '客户管理',
        link: '/client/list',
        icon: 'client_manage',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'analyse',
        name: '数据分析',
        link: '/analyse',
        icon: 'icon_score_status',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'addCreator',
        name: '招募创作者',
        link: '/addCreator',
        icon: 'yyfe-zhanghaoguanli',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'platformRule',
        name: '平台规则',
        link: '/platformRule',
        icon: 'platform-rule',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
];

export const commonGrayMenus: MENUS_CONFIG[] = [
    {
        id: 'manage',
        name: '服务管理',
        link: '/serviceList',
        activeLinks: ['/main/v3/add'],
        icon: 'icon_service_manager',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'order',
        name: '订单管理',
        link: '/main/v3/order',
        activeLinks: ['/refundDetails'],
        icon: 'icon_order',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'financialSettlement',
        name: '财务结算',
        link: '/main/v3/settlement',
        icon: 'icon_settlement',
        iconWidth: 19,
        iconHeight: 19,
        children: [
            {
                id: 'settlement',
                name: '服务市场业务',
                link: '/main/v3/settlement',
            },
            {
                id: 'settlementTP',
                name: '代运营业务',
                link: '/settlementTP/balance',
                matchLink: '/settlementTP',
                activeLinks: ['/invoice'],
            },
        ],
    },
    {
        id: 'score',
        name: '得分状态',
        link: '/score',
        icon: 'icon_score_status',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'evaluation',
        name: '评价管理',
        link: '/evaluation',
        icon: 'icon_comment',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'account',
        name: '账号管理',
        link: '/main/v3/staff',
        icon: 'icon_staff',
        iconWidth: 19,
        iconHeight: 19,
        children: [
            {
                id: 'staff',
                name: '员工管理',
                link: '/main/v3/staff',
                activeLinks: ['/main/groupList', '/main/setMessage', '/main/addStaff'],
            },
            {
                id: 'role',
                name: '角色管理',
                link: '/main/v3/role',
            },
        ],
    },
    {
        id: 'marketing',
        name: '营销中心',
        link: '/main/v3/marketing',
        icon: 'icon_marketting',
        iconWidth: 19,
        iconHeight: 19,
    },
    {
        id: 'messageCenter',
        name: '消息中心',
        link: '/messageCenter',
        icon: 'icon_message',
        activeLinks: ['/contract/cancel'],
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'freight',
        name: '物流管理',
        link: '/freight/list',
        icon: 'icon_freight_setting',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'live',
        name: '直播管理',
        link: '/live/list',
        icon: 'live_manage',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'operations',
        name: '客户管理',
        link: '/store/list',
        icon: 'client_manage',
        iconWidth: 19,
        iconHeight: 19,
        children: [
            {
                id: 'store',
                name: '门店分配',
                link: '/store/list',
            },
            {
                id: 'client',
                name: '合同管理',
                link: '/client/list',
                unreadNumber: 0,
            },
        ],
    },
    {
        id: 'analyse',
        name: '数据分析',
        link: '/analyse',
        icon: 'icon_score_status',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'addCreator',
        name: '招募创作者',
        link: '/addCreator',
        icon: 'yyfe-zhanghaoguanli',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
    {
        id: 'platformRule',
        name: '平台规则',
        link: '/platformRule',
        icon: 'platform-rule',
        iconWidth: 19,
        iconHeight: 19,
        unreadNumber: 0,
    },
];

export const menus: MENUS_CONFIG[] = isCreator
    ? creatorMenus
    : isOutCustomerService
    ? customerServiceMenu
    : commonMenus;

interface MatchLink {
    link: string | string[];
    id: string;
}

export const getMatchLinkList = (menu: any) => {
    const list: MatchLink[] = [];
    menu.forEach(({ id, link, matchLink, children, activeLinks }: any) => {
        if (children) {
            list.push(...getMatchLinkList(children));
            return;
        }
        if (activeLinks) {
            list.push({
                id,
                link: [matchLink || link, ...activeLinks],
            });
        } else {
            list.push({
                link: matchLink || link,
                id,
            });
        }
    });
    return list;
};

export const matchLinkList = getMatchLinkList(menus);

export const iconBackupList = [
    'mtmall-zhanghuzijin',
    'mtmall-guizezhongxin',
    'mtmall-shangpinguanli',
    'mtmall-shujuzhongxin',
];

export interface Menu {
    menuCode: string;
    children?: Menu[];
}

// 递归提取 menuCode 并拉平成数组
function extractMenuCodes(menus: any[]): string[] {
    return menus
        .map(menu => [menu.menuCode, ...(menu.children ? extractMenuCodes(menu.children) : [])])
        .flat();
}

export let cachedResources: string[] | null = null;

export const getResources = async (): Promise<string[]> => {
    if (cachedResources) {
        return cachedResources;
    }

    try {
        const res = await getResourcesList();
        console.log(res);
        const { data } = res;
        if (data && data.menus) {
            const menus: string[] = <string[]>Object.values(data.menus)[0];
            cachedResources = extractMenuCodes(menus); // 提取所有 menuCode
            return cachedResources;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Failed to fetch resources:', error);
        return [];
    }
};
